import { render, staticRenderFns } from "./ePharmacyItemsReceivedList.vue?vue&type=template&id=0fd48c2d&"
import script from "./ePharmacyItemsReceivedList.vue?vue&type=script&lang=js&"
export * from "./ePharmacyItemsReceivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports